module.exports = __webpack_public_path__ + "img/upload_folder.99837310.png";